var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBars3BottomLeftWhite = function SvgBars3BottomLeftWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.25 14.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5zm7-5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0-5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5z"
  })));
};
export default SvgBars3BottomLeftWhite;